import React from 'react'
import LeftSideBar from '../../components/LeftSideBar';
import Title from '../../components/Title';
import InquiryForm from '../InquiryForm';

export const DTAA_Advisory = () => {
  return (
    <div className='services_main_wrapper'>
        <div className='container'>
            <div className='row mt-5 mb-5'>
                <div className='col-md-3'>
                  <LeftSideBar/>
                </div>
                <div className='col-md-9'>
                    <div className='right_side_content'>
                            <div className='section_main_title d-flex align-items-center justify-content-between'>
                                <div className='title_and_icon d-flex align-items-center'>
                                    <img src='/images/datt_icon.jpg'></img>
                                    <Title text="DTAA Advisory" className="custom-heading" />
                                </div>
                                <ul className='d-flex align-items-center'>
                                    <li className='green'>globalization</li>
                                    <li className='orange'>efficiency</li>
                                    <li className='light-blue'>compliance</li>
                                </ul>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='circle_list_wrap mt-1'>
                                        <h4 className="timeline-title mb-2 font-weight-600">DTAA Consulting <sapn className="key_features">Services</sapn></h4>
                                        <p>At Vanani & Associates, we provide expert DTAA advisory and consulting services, ensuring that your income data is managed effectively and that tax calculations are accurate to prevent double taxation. Our DTAA advisors help you maximize rebates, exemptions, and deductions under the applicable tax laws, providing top-quality services for tax return preparation in both countries involved in DTAA transactions.</p>
                                        <p>We excel in providing comprehensive DTAA (Double Taxation Avoidance Agreement) advisory services. Our team of experienced DTAA consultants is dedicated to helping you navigate the complexities of international taxation, optimizing tax liabilities for income and profits earned overseas. We stay updated on global tax and accounting issues, ensuring our clients' transactions are handled with the highest level of proficiency and efficiency.</p>                                           
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-5'>
                                    <div className='img-width'>
                                       <img src='/images/DTAA.jpg' className='image-width' alt='DTAA'></img>
                                    </div>
                                </div>
                                <div className='col-md-7'>
                                    <div className='discriptions'>
                                        <h4 className="timeline-title mb-2 font-weight-600">What is <sapn className="key_features">DTAA?</sapn></h4>
                                        <p>In today's globalized world, businesses are increasingly expanding beyond their home countries, leading to a rise in cross-border transactions. This expansion, while beneficial for growth, brings with it significant challenges in taxation and accounting. One of the primary issues is the risk of double taxation, where the same income is taxed in two different countries. This is where Double Taxation Avoidance Agreements (DTAAs) come into play.</p>
                                        <p>DTAAs are treaties between two countries designed to provide relief from double taxation, making a country more attractive for non-residents to conduct business. These agreements aim to foster economic trade and investment by eliminating the overlapping tax laws of the participating countries. DTAAs can be classified into two types:</p>
                                    </div>
                                    <div className='check_list_wrap mt-4'>
                                        <ul className='mb-0'>
                                            <li><strong>Comprehensive DTAAs</strong>Cover almost all types of incomes. </li>
                                            <li><strong>Limited DTAAs </strong>Cover only specific types of incomes.</li>
                                        </ul>
                                        <p className='mt-3'>Tax relief under DTAAs can be provided in two ways: either by giving a tax credit for the amount paid abroad or by exempting the foreign-earned income from tax in the country of residence. The specific relief depends on the terms of the agreement between the countries involved.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="number_list_wrap essential_points mt-4">
                                <div className="feature-list">
                                    <div className="feature-item">
                                        <div className="icon-box">📋</div>
                                        <div className="feature-content">
                                            <strong className='mb-4'>We assist our clients in structuring their salaries to minimize direct tax liabilities, determining personal investment strategies for achieving the highest tax efficiency, and claiming foreign tax credits on dual-income returns. Our services include preparing the necessary documentation for these transactions, such as:</strong>
                                            <ul className='mt-3 mb-0'>
                                                <li>Tax Residency Certificate (TRC)</li>
                                                <li>Self-attested PAN card copy</li>
                                                <li>Self-attested visa and passport copy</li>
                                                <li>Self-declaration cum indemnity copy</li>
                                                <li>Person of Indian Origin (PIO) proof copy (if applicable)</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                    </div>
                </div>
            </div>
        </div>
        <InquiryForm/>
    </div>
  )
}

export default DTAA_Advisory;
